import { Component, OnInit, ViewChild } from '@angular/core';
import { PropertiesService }  from '../../_services/company/properties.service';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { LoadingService } from '../../_services/loading.service';
import { NotificationService } from '../../_services/notification.service';
import { DatePipe } from '@angular/common';
import { DialogService } from 'src/app/_services/dialog.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-properties',
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.css']
})
export class PropertiesComponent implements OnInit {

  displayedColumns: string[] = ['PropertyName', 'PropertyType', 'Address', 'Phone', 'Fax', 'Email', 'Actions'];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  searchKey: string;

  constructor(private titleService: Title,
    public propertiesService: PropertiesService,
    private dialog: MatDialog,
    public datePipe: DatePipe,
    private dialogService: DialogService,) { }

  ngOnInit() {
    this.titleService.setTitle('School List');
    this.onLoadProperties();
  }

  onLoadProperties() {
    //console.log('ok');
    var result = this.propertiesService.get_properties().subscribe(data=> {
      console.log(data);
      this.dataSource = new MatTableDataSource<any>(data['dataList']);
      this.dataSource.paginator = this.paginator;
      // this.loading.spin$.next(false);
    });
  }

  applyFilter(){
    this.dataSource.filter = this.searchKey.trim().toLocaleLowerCase();
  }
  onSearchClear(){
    this.searchKey = "";
    this.applyFilter();
  }

  onCreate() {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "60%";
    matDialogConfig.position = { top: '0' }
    //this.dialog.open(CreateCompanyDialog, matDialogConfig);
    this.propertiesService.property_form.reset();
    this.dialog.open(CreatePropertyDialog, matDialogConfig).afterClosed().subscribe(res=>{
      this.onLoadProperties();
    });
  }

  onEdit(row) {
    this.propertiesService.populateForm(row);
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "60%";
    matDialogConfig.position = { top: '0' }
    //this.dialog.open(CreatePropertyDialog, matDialogConfig);

    this.dialog.open(CreatePropertyDialog, matDialogConfig).afterClosed().subscribe(res=>{
      this.onLoadProperties();
    });
  }
}





/* Create Property */

@Component({
  selector: 'create-property-dialog',
  templateUrl: 'create-property-dialog.html',
})
export class CreatePropertyDialog {

  constructor(private dialogRef: MatDialogRef<PropertiesComponent>,
    public propertiesService: PropertiesService,
    private loading : LoadingService,
    private notificationService: NotificationService,) {
   }

   onPropertyAddedFormSubmit(formData: any)
   {
     if (this.propertiesService.property_form.valid)
     {
      this.loading.spin$.next(true);

      if(!this.propertiesService.property_form.controls['id'].value)
      {
        // Insert Data
        this.propertiesService.insert_property_details(formData).subscribe(data=>{
          //console.log(data);
          if (data['status']) 
          {
            this.notificationService.success(data['message']);  
            this.propertiesService.property_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          } 
          else 
          {
            this.notificationService.error('Property could not be created, Try Again!');
            this.loading.spin$.next(false);
          }
        });
      }
      else
      {
        // Update Data
        //console.log('data updated');
        this.propertiesService.update_property_details(formData).subscribe(data=>{
          //console.log(data);
          if (data['status']) 
          {
            this.notificationService.success('Property data updated Successfully.');  
            this.propertiesService.property_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          } 
          else 
          {
            this.notificationService.error('Property data could not be updated, Try Again!');
            this.loading.spin$.next(false);
          }
        });
      } 
     }
   }



  onClose(){
    // console.log('Close');
    this.propertiesService.property_form.reset();
    this.dialogRef.close();
  }

}